import React from 'react';
import { Accordion } from '~/components';
import { AA_SURFACE } from '~/modules/Helper/contrast.helper';
import { Content } from './style';

const { Panel } = Accordion;

function FaqItem({ pergunta, resposta }) {
  return (
    <>
      <Accordion
        accordion
        style={{
          marginBottom: 5,
          background: AA_SURFACE,
        }}
      >
        <Panel forceRender header={pergunta} key="1">
          <Content dangerouslySetInnerHTML={{ __html: resposta }} />
        </Panel>
      </Accordion>
    </>
  );
}

export default FaqItem;
